import { Component, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AllService } from '../../rest/all.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from '../../global/global.service';
import { UserSelected } from "../notifications";
import { SupplierService } from '../../rest/Supplier.service';
import { BackService } from '../../rest-model/back.service';
import { NavigationLogoPath } from './NavigationLogoPath';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.css'],
  providers: [AllService, SupplierService, BackService]
})


export class NavigationComponent implements AfterViewInit {
  name: string;
  // showHide: boolean;
  userSelected = new UserSelected;
  languajeSelected = 'es';
  // isEs = false;
  // isEn = false;
  companyAvaList = [];
  companySelected = {
    Id_Company: 0,
    Status: '',
    Id_Supplier_Data: 0,
    CompanyName: '',
    RFC: '',
    EMAIL: '',
    LogoURL: ''
  };
  Id_Supplier_Data = '';
  notificationPending: any;

  PathLogo_ByOrganization: NavigationLogoPath;
  PathLogo_Default: NavigationLogoPath = {
    ExpandMenu_Path: 'assets/images/contaE-logo.png',
    ContractMenu_Path:'assets/images/conta-logo.png'
  }

  hasAccessParamAdmin: boolean = false;


  gToken = localStorage.getItem('key');
  gLanguaje = localStorage.getItem('languaje');
  Supplier_Validity_Fiscal_Opinion: any;
  menuOpen = false;
  menuOpen2 = false;

  constructor(
    private router: Router,
    private allService: AllService,
    private supplierService: SupplierService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private backEndServices: BackService
  ) {
    // this.toastr.setRootViewContainerRef(vcr);
    if (localStorage.getItem('languaje') === 'es') {
      translate.use('es');
      this.languajeSelected = 'es';
      // this.isEs = true;
    } else if (localStorage.getItem('languaje') === 'en') {
      translate.use('en');
      this.languajeSelected = 'en';
      // this.isEn = true;
    } else {
      translate.setDefaultLang('es');
      this.languajeSelected = 'es';
      // this.isEs = true;
      localStorage.setItem('languaje', String('es'));
    }
    this.getUserByTokenSerivice();
    this.supplierAvaCompaListService();
    this.supplierCompaActiveService();
    this.Get_Path_Logo_NavigationServicee();

    this.CheckIfExistsMenuParamAdmin();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.notifPend();
  }

  notifPend() {
    setTimeout(()=>{    //<<<---    using ()=> syntax
      this.notificationPendingService();
      this.notifPend();
    }, 60000);
  }

  async getUserByTokenSerivice() {

    await  this.backEndServices.post_async( {
      entidad: "User",
      funcion: 8,
      data:{}


    } ).then(res => {

          if(res.result){
            this.userSelected = res.data;
            let lengua = 1;
            let leng = localStorage.getItem('languaje');
            if (leng === 'es') {
              lengua = 1;
            } else {
              lengua = 2;
            }

            if (this.userSelected.Id_Language === 1) {
              if (lengua === 2) {
                localStorage.setItem('languaje', String('es'));
                this.languajeSelected = 'es';
              }
            } else {
              if (lengua === 1) {
                localStorage.setItem('languaje', String('en'));
                this.languajeSelected = 'en';
              }
            }

          }


    }).catch(error => {

      localStorage.setItem('key', '');
      localStorage.setItem('jwt', '');
      const redirect = "/authentication/login/Su sesión expiro. Favor de Iniciar sesión de nuevo.";
      this.router.navigate([redirect]);
      // this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      // this.spinner.hide();
    });

    // this.allService.getUserByToken().subscribe(resp => {
    //   this.userSelected = resp;
    //   let lengua = 1;
    //   let leng = localStorage.getItem('languaje');
    //   if (leng === 'es') {
    //     lengua = 1;
    //   } else {
    //     lengua = 2;
    //   }

    //   if (resp.Id_Language === 1) {
    //     if (lengua === 2) {
    //       localStorage.setItem('languaje', String('es'));
    //       this.languajeSelected = 'es';
    //     }
    //   } else {
    //     if (lengua === 1) {
    //       localStorage.setItem('languaje', String('en'));
    //       this.languajeSelected = 'en';
    //     }
    //   }
    // });

  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  toggleMenu2() {
    this.menuOpen2 = !this.menuOpen2;
  }

  logoutService() {

    this.backEndServices.post(
      {
        entidad:'User',
        funcion:33,
        //enviroment: environment.Ambiente,
        data:{
        }
      }

    ).subscribe(
      result => {
      localStorage.setItem('key', '');
      localStorage.setItem('jwt', '');
      //localStorage.setItem('compaNotif', '');
      //localStorage.removeItem('companySelectedLocalName');
      //localStorage.setItem('companySelectedLocalDisaled', '');
      //localStorage.setItem('companySelectedLocal', '');

      const redirect = '/';
      this.router.navigate([redirect]);

    }, error => {

      localStorage.setItem('key', '');
      localStorage.setItem('jwt', '');
      const redirect = '/';
      this.router.navigate([redirect]);
    });
/*
    this.allService.logout().subscribe(resp => {
      localStorage.setItem('key', '');
      localStorage.setItem('jwt', '');
      //localStorage.setItem('compaNotif', '');
      //localStorage.removeItem('companySelectedLocalName');
      //localStorage.setItem('companySelectedLocalDisaled', '');
      //localStorage.setItem('companySelectedLocal', '');

      const redirect = '/';
      this.router.navigate([redirect]);
    });*/
  }

  CheckIfExistsMenuParamAdmin() {

    this.backEndServices.post(
      {
        entidad:'User',
        funcion:32,
        //enviroment: environment.Ambiente,
        data:{
            Id_Tag: environment.Id_Tag,
            AppToken: environment.AppToken
        }
      }

    ).subscribe(
      result => {
        //console.table('result.data', result.data);
        this.hasAccessParamAdmin = result.data.some( menuItem => menuItem.Action === "/supplier/parameters");
        // this.hasAccessParamAdmin = false;
        // console.log('hasAccessParamAdmin:', this.hasAccessParamAdmin);
    }, error => {

      this.hasAccessParamAdmin = false;
      console.error('Error checking access to admin parameters:', error);
    });
   
  }

  redirectNotifications() {
    this.notificationPendingService();

    const redirect = '/notifications/list';
    this.router.navigate([redirect]);
  }

  redirectClientParameters() {
    const redirect = '/supplier/parameters-client';
    this.router.navigate([redirect]);
  }
  redirectAdminParameters() {
    const redirect = '/supplier/parameters';
    this.router.navigate([redirect]);
  }
  redirectManuals() {
    const url = 'https://paper.dropbox.com/doc/Portal-de-Proveedores-Manual-Cliente-axUiZFzOsNAcYSk0aDAvq';
    window.open(url, '_blank');
  }
  selectLanguaje() {
    // if (lang === 'es') {
    //   this.isEs = true;
    //   this.isEn = false;
    // } else {
    //   this.isEs = false;
    //   this.isEn = true;
    // }
    this.updateLanguageService();
  }

  profile() {
    const redirect = '/profile';
    this.router.navigate([redirect]);
  }

  updateLanguageService() {
    this.allService.updateLanguage(this.languajeSelected).subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        localStorage.setItem('languaje', String(this.languajeSelected));
        this.translate.use(this.languajeSelected);
        window.location.reload();
      }
    });
  }

  // changeShowStatus() {
  //     this.showHide = !this.showHide;
  //     localStorage.setItem('menuHide', String(this.showHide));
  // }

  ngAfterViewInit() {


    $("#close_clients").click(function () {
      $(".dropdown_clientes").hide();
    });

    $("#show_clients").click(function () {
      $(".dropdown_clientes").show();
    });

    // dropdown-toggle class not added for submenus by current WP Bootstrap Navwalker as of November 15, 2017.
    $('.dropdown-menu > .dropdown > a').addClass('dropdown-toggle');

    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
      if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
      }
      var $subMenu = $(this).next(".dropdown-menu");
      $subMenu.toggleClass('show');
      $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
        $('.dropdown-menu > .dropdown .show').removeClass("show");
      });
      return false;
    });


    $(function () {
      $(".preloader").fadeOut();
    });

    /* var set = function () {
      var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
      var topOffset = 70;
      if (width < 1569) {
        $("body").addClass("mini-sidebar");
        $('.navbar-brand .expandMenu').hide();
        $('.navbar-brand .contractMenu').show();
        $(".scroll-sidebar, .slimScrollDiv").css("overflow-x", "visible").parent().css("overflow", "visible");
        $(".sidebartoggler i").addClass("ti-menu");
      } else {
        $("body").removeClass("mini-sidebar");
        $('.navbar-brand .icon_logo').hide();
        $(".sidebartoggler i").removeClass("ti-menu");
        $('.navbar-brand .expandMenu').show();
        $('.navbar-brand .contractMenu').hide();
      }

      var height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
      height = height - topOffset;
      if (height < 1) height = 1;
      if (height > topOffset) {
        $(".page-wrapper").css("min-height", (height) + "px");
      }

    }; */


    /* $(window).ready(set);
    $(window).on("resize", set); */

    $(document).on('click', '.mega-dropdown', function (e) {
      e.stopPropagation();
    });

    $(".search-box a, .search-box .app-search .srh-btn").on('click', function () {
      $(".app-search").toggle(200);
    });

    // (<any>$('[data-toggle="tooltip"]')).tooltip();

    // (<any>$('.scroll-sidebar')).slimScroll({
    //     position: 'left',
    //     size: "5px",
    //     height: '100%',
    //     color: '#dcdcdc'
    // });

    // (<any>$('.right-sidebar')).slimScroll({
    //     height: '100%',
    //     position: 'right',
    //     size: "5px",
    //     color: '#dcdcdc'
    // });

    // (<any>$('.message-center')).slimScroll({
    //     position: 'right',
    //     size: "5px",
    //     color: '#dcdcdc'
    // });

    $("body").trigger("resize");

  }

  setCompany(Id_Company) {
    this.supplierSetCompanyService(Id_Company);
  }

  supplierAvaCompaListService() {
    this.allService.supplierAvaCompaList().subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        // this.toastr.success('Se ha eliminado correctamente.', 'Enviado', { toastLife: 10000, showCloseButton: true });
        this.companyAvaList = resp;
      }
    });
  }

  supplierCompaActiveService() {
    this.allService.supplierCompaActive().subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        // this.toastr.success('Se ha eliminado correctamente.', 'Enviado', { toastLife: 10000, showCloseButton: true });

        this.companySelected = resp;
        this.Id_Supplier_Data = resp.Id_Supplier_Data;
      }
    });
  }

  // Supplier_Validity_Fiscal_OpinionService() {
  //   this.supplierService.Supplier_Validity_Fiscal_Opinion().subscribe(resp => {
  //     if (resp.Active === 'V' && resp.Block === 'V' && this.userSelected.UserType === 'S') {
  //       this.Supplier_Validity_Fiscal_Opinion = resp;
  //       // const redirect = '/supplier/edit';
  //       // this.router.navigate([redirect]);

  //     }
  //   });
  // }

  supplierSetCompanyService(Id_Company) {
    this.allService.supplierSetCompany(this.Id_Supplier_Data, Id_Company).subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        // this.toastr.success('Se ha eliminado correctamente.', 'Enviado', { toastLife: 10000, showCloseButton: true });
        window.location.reload();
        // this.TaxRegimeList = resp;
      }
    });
  }

  notificationPendingService() {
    this.allService.notificationPending().subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        // this.toastr.success('Se ha eliminado correctamente.', 'Enviado', { toastLife: 10000, showCloseButton: true });
        this.notificationPending = resp.Notifications;
      }
    });
  }
  //PathLogo_ByOrganization

  Get_Path_Logo_NavigationServicee() {

    this.allService.Get_Path_Logo_Navigation().subscribe(resp => {

      this.PathLogo_ByOrganization = resp;
      if( this.PathLogo_ByOrganization.ContractMenu_Path.length !== 0 &&
          this.PathLogo_ByOrganization.ExpandMenu_Path.length !==0){
            this.PathLogo_Default = this.PathLogo_ByOrganization;
      }

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/header-navigation/navigation.component.ts